import {
  type useAllPOAStatementConsentsRecommendationsQuery,
  type usePOARecommendationsQuery,
  type usePOAStatementConsentsRecommendationsQuery,
} from "@services/powersOfAttorney/queries";
import {
  PowerOfAttorneyHouseAccordion,
  type IPowerOfAttorneyHouseAccordionProps,
} from "./PowerOfAttorneyHouseAccordion";

interface IPowerOfAttorneyHouseAccordionDataWrapperProps
  extends IPowerOfAttorneyHouseAccordionProps {
  powerOfAttorneyLedgerConsentId?: string;
  useRecommendationQueryFn:
    | typeof usePOARecommendationsQuery
    | typeof usePOAStatementConsentsRecommendationsQuery
    | typeof useAllPOAStatementConsentsRecommendationsQuery;
}

export const PowerOfAttorneyHouseAccordionDataWrapper: React.FC<
  IPowerOfAttorneyHouseAccordionDataWrapperProps
> = (props) => {
  const {
    useRecommendationQueryFn,
    jointBillService,
    powerOfAttorneyLedgerConsentId,
    includeRecommendations,
    showExistingConsent,
    isFirst,
    recommendationSource,
  } = props;

  const { data: recommendations } = useRecommendationQueryFn({
    powerOfAttorneyLedgerConsentId: powerOfAttorneyLedgerConsentId!,
    jointBillServiceId: jointBillService.jointBillServiceId,
  });

  return (
    <PowerOfAttorneyHouseAccordion
      jointBillService={jointBillService}
      showExistingConsent={showExistingConsent}
      isFirst={isFirst}
      recommendationSource={recommendationSource}
      {...(includeRecommendations
        ? {
            includeRecommendations: includeRecommendations,
            recommendations: recommendations,
          }
        : {})}
    />
  );
};
